import React from 'react';

import { Link, RouterLinkProps as LinkProps } from 'src/router/components';

type SourceViewLinkProps = Pick<
  LinkProps,
  'target' | 'className' | 'role' | 'onClick' | 'children'
> & {
  viewHref: string;
};

export const SourceViewLink = React.forwardRef(
  (
    props: SourceViewLinkProps,
    ref: (node: HTMLAnchorElement | null) => void
  ) => (
    <Link
      to={props.viewHref}
      target={props.target}
      className={props.className}
      innerRef={ref}
      role={props.role}
      onClick={props.onClick}
    >
      {props.children}
    </Link>
  )
);
